import React from 'react';
type Variant = 'primary' | 'secondary' | 'quiet';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: React.ReactNode;
  iconAfter?: React.ReactNode;
}
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-teal text-white hover:bg-forest border border-teal shadow-[0_8px_18px_-8px_rgba(8,112,132,0.7),inset_0_1px_0_rgba(255,255,255,0.45)]',
  secondary: 'aero-pill text-forest border border-line hover:bg-sand hc-strong',
  quiet: 'bg-transparent text-teal underline-offset-4 hover:underline border border-transparent'
};
export function Button({
  variant = 'primary',
  icon,
  iconAfter,
  className = '',
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={`inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-5 py-2 text-base font-bold transition-colors duration-150 ease-out disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${className}`} {...rest} data-id="element-503" data-mp="395e4wcmeuh6w">
      {icon}
      <span data-id="element-504" data-mp="3fcjg7jq4hj4g">{children}</span>
      {iconAfter}
    </button>;
}